export default "__VITE_ASSET__BO9Apdij__"